export function matchAll(str, regex) {
    const res = [];
    let m;
    if (regex.global) {
        while (m = regex.exec(str)) {
            res.push(m[1]);
        }
    } else {
        if (m = regex.exec(str)) {
            res.push(m[1]);
        }
    }
    return res;
}

//find first parent with tagName [tagname]
export function findParent (tagname: string, el: Element | null) {
    while (el){
        if ((el.nodeName || el.tagName).toLowerCase()===tagname.toLowerCase()){
            return el;
        }
        // @ts-ignore
        el = el.parentNode;
    }
    return null;
}